<template>
    <div class="session-one p-r m-0-a" :style="{backgroundImage: 'url(' + info.gif + ')' }">
        <div class="btn-warp p-a">
            <a :href="info.language_btn.btn_link" class="language-btn d-i-b" @click="goLink" v-if="info.language_btn.btn_ch">
                <img :src="info.language_btn.btn_ch" alt="" @click="Ga('language')">
            </a>
            <div @click="stopMusic" class="music-btn d-i-b" v-if="info.btn_music">
                <img :src="info.btn_music" alt="" :class="{'rotate':rotate}">
            </div>
            <audio :src="musicSrc" loop ref="music" v-if="info.btn_music">
                                                                                                                                                您的浏览器不支持 audio 标签。
                                                                                                                                                </audio>
        </div>
        <i class="logo d-b p-a"><img :src="info.logo" alt=""></i>
        
    </div>
</template>
<style lang="less" scoped>
    .rotate {
        animation: rote linear 5s infinite;
        -webkit-animation: rote linear 5s infinite;
    }
    @keyframes rote {
        0% {
            transform: rotateZ(0);
        }
        100% {
            transform: rotateZ(360deg);
        }
    }
    @-webkit-keyframes rote {
        0% {
            transform: rotateZ(0);
        }
        100% {
            transform: rotateZ(360deg);
        }
    }
    .session-one {
        width: 7.706667rem;
        height: 11.573333rem;
        top: .4rem;
        -webkit-animation: mbStep 1.5s steps(15) infinite;
        animation: mbStep 1.5s steps(15) infinite;
        background-repeat: no-repeat;
        background-size: cover;
    }
    @keyframes mbStep {
        from {
            background-position: 0 0;
        }
        to {
            background-position: -115.6rem 0;
        }
    }
    @-webkit-keyframes mbStep {
        from {
            -webkit-background-position: 0 0;
        }
        to {
            -webkit-background-position: -115.6rem 0;
        }
    }
    .btn-warp {
        height: .693333rem;
        top: .266667rem;
        right: .266667rem;
        .language-btn {
            width: 1.413333rem;
            height: .693333rem;
            margin-right: .366667rem;
        }
        .music-btn {
            width: .64rem;
            height: .64rem;
            cursor: pointer;
        }
    }
    .logo {
        width: 4.64rem;
        height: 2.426667rem;
        top: 6rem;
        left: 50%;
        margin-left: -2.32rem;
    }
    
    img {
        max-width: 100%;
    }
    @media screen and (min-width:1025px) {
        [pc="1"] .session-one {
            width: 578px;
            height: 868px;
            -webkit-animation: pcStep 3s steps(15) infinite;
            animation: pcStep 3s steps(15) infinite;
        }
        @keyframes pcStep {
            from {
                background-position: 0 0;
            }
            to {
                background-position: -8670px 0;
            }
        }
        @-webkit-keyframes pcStep {
            from {
                -webkit-background-position: 0 0;
            }
            to {
                -webkit-background-position: -8670px 0;
            }
        }
        [pc="1"] .logo {
            width: 348px;
            height: 182px;
            top: 450px;
            margin-left: -174px;
        }
        
    }
</style>
<script>
    import Util from "@util/index.js";
    export default {
        props: ['info', 'gameCode', 'lan'],
        data() {
            return {
                isPlaying: false,
                rotate: false
            }
        },
        computed: {
            musicSrc() {
                return `https://res-download.vsplay.com/res_eu/activity/${this.gameCode}/gw/music.mp3`
            },
        },
        methods: {
            stopMusic() {
                const audio = this.$refs.music;
                if (this.isPlaying) {
                    audio.pause();
                    this.rotate = false;
                    this.isPlaying = false;
                } else {
                    audio.play();
                    this.rotate = true;
                    this.isPlaying = true;
                }
            },
            
            goLink() {
                Util.addSesstion('chooseLanguage', true, 8)
                window.location.href = this.info.language_btn.btn_link
            },
            Ga(_type) {
                if (_type == 'language') {
                    Util.trackGA('点击', '跳转至' + this.lan + ' :页面', '跳转至' + this.lan + ' :页面');
                } else {
                    Util.trackGA('点击', '跳转至' + this.lan + ' :页面', this.lan + ' :领取礼包按钮');
                }
                window.location.href = this.info.link;
            }
        }
    }
</script>





// WEBPACK FOOTER //
// client/smsgz/components/index/session-one.vue